import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=d60b2294&"
import script from "./Kanban.vue?vue&type=script&lang=js&"
export * from "./Kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60b2294')) {
      api.createRecord('d60b2294', component.options)
    } else {
      api.reload('d60b2294', component.options)
    }
    module.hot.accept("./Kanban.vue?vue&type=template&id=d60b2294&", function () {
      api.rerender('d60b2294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/kanban/Kanban.vue"
export default component.exports